import {apiCall} from './index.ts';

export type ClickActionData = {
    audio?: ClickAudioConfig;
    clickAction?: {
        selectionAppearance?: any;
        [k: string]: any;
    };
    [k: string]: any;
};

export type ClickAudioConfig = {
    url: string;
    label?: string;
    uploadId?: string;
    loop: boolean;
    /** Total number of times the audio plays, including the first play. */
    playCount: number;
    /** Stops the audio the next time the presentation changes slides. Defaults to false. */
    stopOnSlideChange?: boolean;
};

export type BlockAction = {
    slideId: number;
    blockId: string;    // stable ID attached to block's metadata

    x: number;
    y: number;
    width: number;
    height: number;

    duration?: number;
    timeOffset?: number;

    clickActionType?: string;
    clickActionTarget?: string;
    clickActionData?: ClickActionData;

    interactionData?: { [key: string]: any };           // panel/interaction-defined
};

// Published slide info type
export type SlideInfo = {
    id: number;

    slideIndex?: number;        // Order ID of this slide in the scene, starting from 0
    name?: string;
    muteBackgroundMusic?: boolean;
    autoAdvanceAfterNarration?: boolean;
    autoAdvanceSlideId?: string;
    slideData: string | null;

    introSlide: boolean;
    isMenuSlide?: boolean;      // Designate this slide as a menu destination
    showMenuButton?: boolean;   // Control menu button visibility on this slide
    menuButtonColor?: string;   // Color of the menu button on this slide
};

export type BootAnimateOptions = {
    /** URL to CreateJS (if not already present). Example: '/libs/createjs.min.js' */
    createjsUrl?: string;
    /** URL to the Animate export JS (the file that registers the composition). */
    slideJsUrl: string;
    /** The composition id inside slide.js (lib.properties.id). */
    compositionId: string;
    /** IDs of elements inside your overlay*/
    ids?: {
        canvas?: string;                 // default: 'canvas'
        animContainer?: string;          // default: 'animation_container'
        domOverlay?: string;             // default: 'dom_overlay_container'
    };
    /** Optional: autoplay once initialized (default true). */
    autoplay?: boolean;
};

export type ToggleSelectionAction = {
    type: 'toggleSelection';
    // optional UX/storage settings
    selected?: boolean;            // initial default
    store?: boolean;               // put into a “variables” bag
    varName?: string;              // e.g. "varColor"
    value?: string;                // e.g. "Green"
    deselectValue?: string;        // e.g. ""
    appearance?: {                 // optional appearance overrides
        opacity?: number;            // 0..1 when selected
        filter?: string;             // e.g. "brightness(1.1)"
        scale?: number;              // e.g. 1.02
        outline?: string;            // e.g. "3px solid #16a8ff"
    };
};

export type Song = {
    id: string;
    name: string;
    directory: string;
    enabled: string
};

type License = {
    licenseKey: string;
};

export async function getLicenseKey(): Promise<string>{
    const response = await apiCall<License>(`/presentations/license`, {method: 'GET'});
    return response?.licenseKey;
}

export async function getSlides(urlCode?: string, previewToken?: string): Promise<SlideInfo[]> {
    return apiCall<SlideInfo[]>(`/presentations/slides`,
        {
            method: 'POST',
            data: {
                urlCode: urlCode,
                previewToken: previewToken,
            }
        });
}
